import getCdnUrl from '@fingo/lib/helpers/get-cdn-url';

const LandingInvoicesImage = getCdnUrl('/landings/register-landing-main.webp');

export default LandingInvoicesImage;
